import React, { useEffect, useState, useCallback } from 'react'
import JsonViewModal from '../viewJson/index'
import AddressExpandedRecord from './address/AddressExpandedRecord'
import HeaderExpandedRecord from './header/HeaderExpandedRecord'
import MostRecentData from './MostRecentData/MostRecentData'
import styles from './styles.module.css'
// import OwnerExpandedRecord from "./Owner/OwnerExpandedRecord";
import Description from './Descriptions/Descriptions'
import Exterior from './Exterior/Exterior'
import Features from './Features/Features'
import Images from './ImagesSection/Images'
import Interior from './Interior/Interior'
import LegalDescription from './LegalDescription/LegalDescription'
import OwnerExpandedRecord from './Owner/OwnerExpandedRecord'
import Parking from './Parking/Parking'
import PriceExpandedRecords from './Price/PriceExpandedRecords'
import StatusHistory from './StatusHistory/StatusHistory'
import TransactionsHistory from './TransactionsHistory/TransactionsHistory'
import useStore from '../Store/Store'
import useStoreSubscription from '../PeopleDataDR14/SubscribeTray/SubscriptionStore'
import { useMutation } from 'react-query'
import { postPeopleByKey, getAccount } from '../../Api/index'
import { useQuery } from 'react-query'
import ExpandedRecordsPeople from '../PeopleDataDR14/ExpandedRecords/ExpandedRecordsPeople'
import SubscriptionIndex from '../PeopleDataDR14/SubscribeTray/SubscriptionIndex'
import PeopleExpanded from './People/People'
import BaseAlert from '../Snackbar/NewImplementations/BaseAlert/BaseAlert'
import { useHistory } from 'react-router-dom'
import useEscapeKey from '../utils/useEscapeKey'

function ExpandedRecordDr6 ({
  recordData,
  onClose,
  isLoadingRecord,
  errorNotEnoughCredits,
  setErrorNotEnoughCredits,
  snackBarStateError
}) {
  const { setShouldRefetch } = useStore()
  const history = useHistory()
  const [errorAlert, setErrorAlert] = useState({
    open: false,
    title: '',
    body: '',
    color: '',
  })
  const { isPaymentSuccessful, setIsPaymentSuccessful } = useStoreSubscription()
  const { data: AccountData } = useQuery('account', getAccount)
  const [isVisible, setIsVisible] = useState(false)
  const [showOwnerModal, setShowOwnerModal] = useState(false)
  const [isJsonModalVisible, setIsJsonModalVisible] = useState(false) // State for JSON modal visibility
  // const record = recordData
  const [isQueryLoadingPeople, setIsQueryLoadingPeople] = useState(false)
  const [peopleRecord, setPeopleRecord] = useState(null)
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false)

  const toggleJsonModal = () => {
    setIsJsonModalVisible(true) // Toggle JSON modal visibility
  }
  const [record, setRecord] = useState(recordData) // Manage record as internal state

  const [searchPeopleByKey] = useMutation(
    ({ peopleKey }) => postPeopleByKey(peopleKey),
    {
      onMutate: () => {
        setIsQueryLoadingPeople(true)
      },
      onSuccess: (data, variables) => {
        setPeopleRecord(data?.data?.records[0])
        setShowOwnerModal(true)
      },
      onError: error => {
        // Handle errors as needed
        console.error('Error fetching people data:', error)
      },
      onSettled: () => {
        setIsQueryLoadingPeople(false)
      }
    }
  )

  const openOwnerModal = useCallback(() => {
    const isAdmin = AccountData?.data?.role === 'admin'
    const peoplePlan = AccountData?.data?.plans?.find(
      plan => plan.dataType === 'people'
    )
    const isUserWithPeoplePlan =
      AccountData?.data?.role === 'user' && peoplePlan

    // if (isAdmin && !isUserWithPeoplePlan) {
    //   setShowSubscriptionModal(true)
    //   return
    // }
    if (!isAdmin && !isUserWithPeoplePlan) {
      setShowSubscriptionModal(true)
      return
    }

    // For non-admin users with a People plan, check credits
    if (!isAdmin) {
      const creditsUsed = AccountData?.data?.people_credits_used || 0
      const creditsAllotted = peoplePlan?.credits_allotted || 0
      // If they've used up or exceeded their credits, prompt to subscribe
      if (creditsUsed >= creditsAllotted) {
        setShowSubscriptionModal(true)
        return
      }
    }
    const ownerPerson = record?.people?.find(
      person => person.title?.toLowerCase() === 'owner'
    )
    if (ownerPerson?.people_key) {
      searchPeopleByKey({ peopleKey: ownerPerson.people_key })
    }
  }, [AccountData, record, searchPeopleByKey])

  const closeOwnerModal = () => {
    setShowOwnerModal(false)
  }

  useEffect(() => {
    // Trigger the slide-in effect when the component mounts
    if (record || isLoadingRecord) {
      const timeoutId = setTimeout(() => {
        setIsVisible(true)
      }, 1)

      return () => clearTimeout(timeoutId)
    }
  }, [record, isLoadingRecord])

  const handleClose = () => {
    if (!isJsonModalVisible) {
      // Start the slide-out effect
      setIsVisible(false)
      // Use a timeout to match the CSS transition duration
      setTimeout(() => {
        onClose()
      }, 250) // Adjust timeout to match your CSS transition
    }
  }

  useEscapeKey(handleClose)

  useEffect(() => {
    setRecord(recordData)
    setShouldRefetch(true)
  }, [recordData, setShouldRefetch])

  useEffect(() => {
    if (isPaymentSuccessful === true) {
      setTimeout(() => {
        openOwnerModal()
      }, 250)
    }
    setIsPaymentSuccessful(false)
  }, [isPaymentSuccessful, openOwnerModal, setIsPaymentSuccessful])

  useEffect(
    () => {
      if (snackBarStateError) {
        setErrorAlert({
          open: true,
          title: 'Requesting too many records',
          body: "The number of records you're requesting exceeds the available records remaining on your plan. Try narrowing your search or upgrade your account for more record credits.",
          color:"#000000"
        })
      }
      if (errorNotEnoughCredits) {
        // handleClose()
        setErrorNotEnoughCredits(false)
      }
    },
    /* eslint-disable-line react-hooks/exhaustive-deps */ [
      errorNotEnoughCredits,
      snackBarStateError
    ]
  )

  if (isLoadingRecord || !record) {
    return (
      <div className={styles.modalBackdropExpandedRecord} onClick={handleClose}>
        <div
          className={styles.modalContentExpandedRecord}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: isVisible ? 'translateX(0)' : 'translateX(100%)'
          }}
          onClick={e => e.stopPropagation()}
        >
          <p>Loading details...</p> {/* Show loading text or spinner */}
        </div>
        {/* <SnackbarComponent snackData={snackMessage} /> */}

        <BaseAlert
          open={errorAlert.open}
          title={errorAlert.title}
          body={errorAlert.body}
          color={errorAlert.color}
          actions={[
            {
              label: 'Upgrade account',
              onClick: () => history.push('/settings/billing/subscription')
            },
            {
              label: 'Ok',
              onClick: () => setErrorAlert({ ...errorAlert, open: false })
            }
          ]}
          onClose={() => setErrorAlert({ ...errorAlert, open: false })}
          style={{width:"320px"}}
        />
      </div>
    )
  }

  return (
    <div className={styles.modalBackdropExpandedRecord} onClick={handleClose}>
      {/* onClick={handleClose} */}
      <div
        className={styles.modalContentExpandedRecord}
        style={{ transform: isVisible ? 'translateX(0)' : 'translateX(100%)' }}
        onClick={e => e.stopPropagation()}
      >
        {/* HEADER */}
        <HeaderExpandedRecord
          record={record}
          handleClose={handleClose}
          toggleJsonModal={toggleJsonModal}
        />
        {/* HEADER */}
        {/* Location/Address */}
        <AddressExpandedRecord record={record} />
        {/* Most Recent data */}
        <MostRecentData record={record} />

        {/* Most Recent */}

        {/* Owner */}
        <OwnerExpandedRecord record={record} onClick={openOwnerModal} />
        <hr className={styles.hrStyles} />

        {/* Images */}
        <Images record={record} />

        <hr className={styles.hrStyles} />

        {/* Prices, Status */}
        <div>
          <div className={styles.priceStatusContainer}>
            <PriceExpandedRecords record={record} />
            {/*  */}
            <StatusHistory record={record} />
            {/*  */}
          </div>
          <hr className={styles.hrStyles} />
          {/*  */}
          {/* legal description */}
          <LegalDescription record={record} />
          <hr className={styles.hrStyles} />
          <Description record={record} />
          <hr className={styles.hrStyles} />
          {/*  */}
          {/* Transactions History */}
          <TransactionsHistory record={record} />
          <hr className={styles.hrStyles} />

          <PeopleExpanded record={record} />
          <hr className={styles.hrStyles} />

          <div style={{ marginTop: '22px' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: '18px'
              }}
            >
              <Parking record={record} />
              <Exterior record={record} />
              {/* <TBD /> */}
            </div>
            {/*  */}

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: '24px'
              }}
            >
              <Interior record={record} />
            </div>

            {/*  */}
            <hr style={{ border: '1px solid #E5E5E5', margin: '0px -40px' }} />
            <Features record={record} />
          </div>
        </div>
      </div>

      {showOwnerModal && (
        <ExpandedRecordsPeople
          recordData={peopleRecord}
          onClose={closeOwnerModal}
          isLoadingRecord={isQueryLoadingPeople}
          isPropertyFunctionality={true}
        />
      )}

      {showSubscriptionModal && (
        <SubscriptionIndex
          setShowSubscriptionModal={setShowSubscriptionModal}
        />
        // onClose={() => setShowSubscriptionModal(false)}
      )}
      {isJsonModalVisible && (
        <JsonViewModal
          jsonData={record}
          onClose={() => setIsJsonModalVisible(false)}
        />
      )}
    </div>
  )
}

export default ExpandedRecordDr6
